module.exports = __webpack_public_path__ + "static/img/3401_phase_function_Paper_PointsHejduk_Prediction.9982780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3401_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 8Nes
// module chunks = 0